// extracted by mini-css-extract-plugin
module.exports = {"slider":"styles-module--slider--3HbB-","button":"styles-module--button--Lp4eN"};